import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';

// hard-coded instead of using useInsuranceLines api as they do not match the line of business values / and have extras
const LINE_OF_BUSINESS_OPTIONS = [
  'Accident',
  'Excess Liability',
  'Management Liability',
  'Package',
  'Primary General Liability',
].map((name) => ({ key: name, label: name, value: name }));

export interface LineOfBusinessTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

export const LineOfBusinessTypeaheadFilter = (componentProps: LineOfBusinessTypeaheadFilterProps) => {
  const { value, disabled } = componentProps;

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={LINE_OF_BUSINESS_OPTIONS}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      horizontalLabel={true}
    />
  );
};
